// BUG-31 — Thin wrappers for the Integration Monitoring endpoints.
// Backend (t2tIntegrationModel.js) already exposes all four; this file just
// gives the Reports → Integration Health tab a clean import surface.

import { getData, postData } from "../FetchApiServices";

// GET /api/t2t/integrations/health — per-integration health card data
export const fetchIntegrationHealth = () => getData("t2t/integrations/health");

// GET /api/t2t/integrations/call-log — unified call log, filterable
// filters: { type, status, date_from, date_to, limit }
export const fetchIntegrationCallLog = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.type)      params.set("type", filters.type);
  if (filters.status)    params.set("status", filters.status);
  if (filters.date_from) params.set("date_from", filters.date_from);
  if (filters.date_to)   params.set("date_to", filters.date_to);
  params.set("limit", String(filters.limit || 100));
  return getData(`t2t/integrations/call-log?${params.toString()}`);
};

// POST /api/t2t/integrations/call-log/:id/retry — manual retry button
export const retryIntegrationCall = (logId) => postData(`t2t/integrations/call-log/${logId}/retry`, {});

// GET /api/t2t/integrations/cost-tracker?month=YYYY-MM — verification API spend
export const fetchIntegrationCostTracker = (month) => {
  const q = month ? `?month=${encodeURIComponent(month)}` : "";
  return getData(`t2t/integrations/cost-tracker${q}`);
};
